"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var network_1 = __importDefault(require("../core/network"));
var WebNetwork = /** @class */ (function (_super) {
    __extends(WebNetwork, _super);
    function WebNetwork() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebNetwork.prototype.listenConnectionStateChanges = function () {
        var _this = this;
        // bad. should create node environment.
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('online', function () { return _this.connectionIsOnline(); });
    };
    return WebNetwork;
}(network_1.default));
exports.default = WebNetwork;
//# sourceMappingURL=network.js.map